module.exports = __webpack_public_path__ + "img/顺德农业农村局.f69deb81.png";